package com.gsb.vyapar.bhagya.interactor.uistate

import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.snapshots.SnapshotStateMap
import androidx.compose.ui.graphics.ImageBitmap
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.BUSINESS
import com.gsb.vyapar.bhagya.domain.Categories
import com.gsb.vyapar.bhagya.domain.Config
import com.gsb.vyapar.bhagya.domain.Info
import com.gsb.vyapar.bhagya.domain.SubCategories
import com.gsb.vyapar.bhagya.domain.User
import com.gsb.vyapar.bhagya.domain.decodeCategoriesString
import com.gsb.vyapar.bhagya.domain.decodeConfigString
import com.gsb.vyapar.bhagya.domain.decodeInfoString
import com.gsb.vyapar.bhagya.domain.decodeSubCategoriesString
import com.gsb.vyapar.bhagya.domain.decodeUserString
import com.gsb.vyapar.bhagya.domain.encodeConfigString
import com.gsb.vyapar.bhagya.domain.getBusinessNumber
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.interactor.util.checkImageCache
import com.gsb.vyapar.bhagya.interactor.util.checkImageCacheCallback
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.Screens.*
import com.gsb.vyapar.bhagya.presentation.admin.uistate.AdminUiState
import com.gsb.vyapar.bhagya.presentation.auth.uistate.AuthUiState
import com.gsb.vyapar.bhagya.presentation.bottomsheet.BottomSheets
import com.gsb.vyapar.bhagya.presentation.business.uistate.BusinessUiState
import com.gsb.vyapar.bhagya.presentation.category.uistate.CategoriesViewUiState
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState
import com.gsb.vyapar.bhagya.presentation.search.uistate.SearchUiState
import com.gsb.vyapar.bhagya.presentation.searchlist.uistate.SearchListUiState
import com.gsb.vyapar.bhagya.presentation.location.uistate.LocationUiState
import com.gsb.vyapar.bhagya.toComposeImageBitmap
import com.gsb.vyapar.bhagya.util.Stack

data class UiState(
    val isPortrait: Boolean = true,
    val mainView: Screens = Splash,
    val navView: Screens? = null,
    val navViewStack: Stack<Screens> = Stack(),
    val loadingUiState: DialogUiState? = null,
    val config: String = Preference.config,
    val categories: String = Preference.categories,
    val subCategories: String = Preference.subCategories,
    val info: String = Preference.info,
    val user: String = Preference.user,
    val imageMap: SnapshotStateMap<String, ImageBitmap> = mutableStateMapOf(),
    val bottomSheetView: BottomSheets? = null,
    val categoriesViewUiState: CategoriesViewUiState = CategoriesViewUiState(),
    val errorUiState: DialogUiState? = null,
    val successUiState: DialogUiState? = null,
    val authUiState: AuthUiState = AuthUiState(),
    val businessUiState: BusinessUiState = BusinessUiState(),
    val adminUiState: AdminUiState = AdminUiState(),
    val searchUiState: SearchUiState = SearchUiState(),
    val dialogUiState: DialogUiState? = null,
    val deepLink: String? = null,
    val searchListUiState: SearchListUiState = SearchListUiState(),
    val locationUiState: LocationUiState = LocationUiState(),
) {
    fun getConfig(): Config {
        return config.decodeConfigString()
    }

    fun getCategories(): Categories {
        return categories.decodeCategoriesString()
    }

    fun getSubCategories(): SubCategories {
        return subCategories.decodeSubCategoriesString()
    }

    fun getInfo(): Info {
        return info.decodeInfoString()
    }

    fun getUser(): User {
        return user.decodeUserString()
    }

    fun getImage(url: String): ImageBitmap? {
        checkImageCache(url)
        return imageMap[url]
    }

    fun getImageCallback(url: String, onBitmap: (ImageBitmap?) -> Unit) {
        checkImageCacheCallback(url, onBitmap)
    }

    fun getNextBusinessId(): Int {
        val nextIndex = getConfig().getBusinessNumber()
        var newConfig = getConfig()
        newConfig = newConfig.copy(d = newConfig.d.copy(config = newConfig.d.config + (BUSINESS to (nextIndex + 1))))
        updateState(getState().copy(config = newConfig.encodeConfigString()))
        Preference.config = getState().config
        return nextIndex
    }
}
